var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "o-wrapper" }, [
    _c("div", { staticClass: "o-layout o-layout--center u-mb-20" }, [
      _c("div", { staticClass: "o-item  u-6/12@desktop" }, [
        _c(
          "div",
          {
            staticClass:
              "o-layout o-layout--matchheight o-layout--center o-layout--stacked"
          },
          _vm._l(_vm.tabs, function(tab, index) {
            return _c(
              "div",
              { key: tab.title, staticClass: "o-item  u-4/12@tablet" },
              [
                _c(
                  "a",
                  {
                    staticClass: "card c-card-result",
                    class: { "is-active": index == _vm.selectedIndex },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.selectTab(index)
                      }
                    }
                  },
                  [
                    tab.$slots.button
                      ? _c("vnodes", { attrs: { vnodes: tab.$slots.button } })
                      : _c("h3", { staticClass: "u-h5" }, [
                          _vm._v(_vm._s(tab.title))
                        ])
                  ],
                  1
                )
              ]
            )
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "o-layout o-layout--center" }, [
      _c("div", { staticClass: "o-item  u-8/12@desktop" }, [
        _c("div", { staticClass: "content" }, [_vm._t("default")], 2)
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }